<script lang="ts" setup>
import { ParagraphContainerWidgetMain } from '~/api/graphql/generated'

const props = defineProps<{
  entity: ParagraphContainerWidgetMain
}>()
const sections = props.entity.fieldContainerWidget
  ?.map((item) => {
    if (!item || !item.entity) {
      return false
    }
    return {
      __typename: item.__typename,
      entity: item.entity,
    }
  })
  .filter(Boolean)
</script>

<template>
  <Sections v-for="(item, index) in sections" :key="index" :entity="item.entity" />
</template>
